import Typography from '@mui/material/Typography';
import Logo from '../Logo/Logo';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@/components/Link/Link';
import footerBg from '@/assets/footer-rectangle.svg';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const linkStyles = {
    textDecoration: 'none',
    '&:hover': {
      color: 'secondary.main'
    }
  };

  return (
    <Box
      component='footer'
      sx={{
        minWidth: '300px',
        width: '100%',
        padding: 5,
        backgroundImage: `url(${footerBg})`,
        backgroundColor: 'primary.dark',
        backgroundSize: 'cover'
      }}
    >
      <Container maxWidth='sm' sx={{ p: 0 }}>
        <Stack alignItems='center'>
          <Typography align='center' variant='body2' color='white'>
            {t('components.footer.akova-title')}
          </Typography>
          <Typography align='center' variant='body2' color='white'>
            {t('components.footer.akova-org-number')}
          </Typography>
          <Typography align='center' variant='body2' color='white'>
            {t('components.footer.akova-address')}
          </Typography>
          <Typography align='center' variant='body2' color='white'>
            {t('components.footer.akova-phone-number')} 08-12 12 12 12
          </Typography>
          <Typography align='center' variant='body2' color='white'>
            {t('common-phrases.email')}{' '}
            <Link
              href='mailto:hej@akova.se'
              fontWeight='medium'
              fontStyle='italic'
              color='primary.light'
              sx={linkStyles}
            >
              hej@akova.se
            </Link>
          </Typography>
          <Typography sx={{ marginTop: 2, marginBottom: 4 }} align='center' variant='body2' color='primary.light'>
            <Link
              href={
                currentLanguage === 'sv' ? 'https://akova.se/integritetspolicy/' : 'https://akova.se/en/privacy-policy/'
              }
              fontWeight='medium'
              fontStyle='italic'
              target='_blank'
              color='inherit'
              sx={linkStyles}
            >
              {t('common-phrases.privacy-policy')}
            </Link>
          </Typography>
          <Link href={currentLanguage === 'sv' ? 'https://akova.se' : 'https://akova.se/en'}>
            <Logo height='23px' width='92px' type='akova-white' />
          </Link>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
